<!--
 Copyright 2024 Google LLC.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
-->

<div class="new-exp-input-fields new-exp-text-style">
  <h2 i18n>Select Plan</h2>
  <div *ngIf="splittingResults">
    <mat-form-field>
      <mat-label i18n>Select Plan</mat-label>
      <mat-select [(value)]="selectedResultSet" matTooltipClass="max-width-tooltip" required
        [matTooltip]="helpMessagesService.experimentCommonInputFields.SELECT_PLAN">
        <mat-option
          *ngFor="let resultSet of splittingResults.splitting_result_sets; index as i"
          [value]="i" (click)="updateTableDataWhenChangingPlan()">{{"Plan_" + (i + 1)}}</mat-option>
      </mat-select>
    </mat-form-field>
    <div *ngIf="canDisplayResultSetInformation">
      <app-group-member-allocations-table [groupMembers]="groupMembers" />
    </div>
    <div *ngIf="canDisplayResultSetInformation">
      <app-data-table [tableTitle]="'Pre-Experiment Aggregated KPI per Group'"
        [matTooltip]="helpMessagesService.splittingResultsPage.TABLE_KPI_PER_GROUP"
        matTooltipClass="unset-max-width-tooltip"
        [canOverflow]="true"
        [dataFrame]="kpiDataframe">
      </app-data-table>
    </div>
    <app-selector-for-test-groups (testGroupsSelectionModified)="emitGroupsSelection($event)"
      [testGroupsSelection]="allPossibleTestGroupsForSelection"/>
    <h2 i18n *ngIf="isImpactMeasurement()">Members to Exclude</h2>
  </div>
  <ng-container *ngIf="isImpactMeasurement()">
    <app-selector-for-member-exclusion [groupLabel]="'Control'" [membersList]="groupMembers[0]"
      [selectedMembersControl]="groupMembersToExclude.get('Control')!" *ngIf="groupMembers"
      [matTooltip]="helpMessagesService.continueToImpactMeasurementPage.SELECT_MEMBERS_EXCLUDE"
      matTooltipClass="unset-max-width-tooltip"/>
    <app-selector-for-member-exclusion *ngFor="let testGroup of selectedTestGroups"
      [groupLabel]="testGroup"
      [membersList]="groupMembers[convertToTestGroupIndex(testGroup)]"
      [selectedMembersControl]="groupMembersToExclude.get(testGroup)!"
      [matTooltip]="helpMessagesService.continueToImpactMeasurementPage.SELECT_MEMBERS_EXCLUDE"
      matTooltipClass="unset-max-width-tooltip"/>
  </ng-container>
</div>
